import { RESET_STATE } from "../reducers/types";

export interface IResetState {
  type: RESET_STATE;
}

export const resetState = (): IResetState => ({
  type: RESET_STATE,
});
